module.exports = __webpack_public_path__ + "static/ltc-fad686fd4fb48d2f8825730f6279ac6f.png";